import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class QuantityMustBeGreaterThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.items.quantity.must-be-greater-than-zero');
    }
}
